import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDownIcon, ArrowRightIcon, CalendarDaysIcon, CheckIcon, LeafIcon, ListChecksIcon, MonitorSmartphoneIcon, StarIcon } from 'lucide-react';
import { checkoutUrl, handleCheckoutClick } from '../utils/checkout';
const learningPoints = ['Dejarás de preguntarte cada día qué cocinar.', 'Comerás rico sin sentir que estás a dieta.', 'Sabrás qué elegir aunque tengas poco tiempo.', 'Cocinarás con confianza, aunque no sea lo tuyo.', 'Tu semana estará resuelta antes de empezar.', 'Podrás darte un gusto sin culpa después.', 'Dejarás de volver a empezar cada lunes.', 'Sentirás que esta vez sí puedes sostenerlo.'];
export function HeroSystem() {
  return <>
      <section id="inicio" className="relative overflow-hidden bg-[#f5f4ed]" data-id="element-88" data-mp="2f5010j7gw9p8">
        <img src="https://images.unsplash.com/photo-1556911220-bff31c812dba?auto=format&fit=crop&w=2200&q=85" alt="Cocina moderna iluminada por luz natural" className="absolute inset-0 h-full w-full object-cover opacity-[0.20]" data-id="element-89" data-mp="2k65valgs050v" />
        <div className="relative mx-auto grid min-h-[760px] max-w-7xl items-center gap-12 px-5 pb-28 pt-16 sm:px-8 sm:py-16 lg:grid-cols-[1fr_1.05fr] lg:py-24" data-id="element-90" data-mp="g14frd1naa2v">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7
        }} className="order-2 max-w-2xl lg:order-1" data-id="element-91" data-mp="b4nh3owtkdbj">
            <p className="mb-6 text-xs font-bold tracking-[0.2em] text-[#6f8061]" data-id="element-92" data-mp="u15f2o29h9g8">
              PARA QUIEN YA INTENTÓ DE TODO
            </p>
            <h1 className="font-display text-4xl leading-[1.08] text-[#2d3b2c] sm:text-5xl lg:text-6xl" data-id="element-93" data-mp="p1khagytv753">
              Deja de empezar de cero cada lunes y vuelve a sentirte bien{' '}
              <em className="font-normal" data-id="element-94" data-mp="1hpyewvm081g4">en tu propia rutina.</em>
            </h1>
            <p className="mt-7 max-w-xl text-lg leading-8 text-[#606b5d]" data-id="element-95" data-mp="3bybqonapl3fm">
              Sin reglas imposibles ni culpa después de comer. Solo decisiones
              simples que puedes sostener, incluso en las semanas complicadas.
            </p>
            <div className="mt-9 flex flex-col gap-3 sm:flex-row" data-id="element-96" data-mp="328s71ff695jp">
              <a href={checkoutUrl} onClick={handleCheckoutClick} className="inline-flex min-h-14 items-center justify-center rounded-full bg-[#405a3b] px-7 text-sm font-bold tracking-[0.06em] text-white transition-colors hover:bg-[#30452e]" data-id="element-97" data-mp="3773fpmtqda0c">
                QUIERO RECUPERAR EL CONTROL{' '}
                <ArrowRightIcon className="ml-2" size={17} data-id="element-98" data-mp="2o99a7irt9gmp" />
              </a>
              <a href="#incluye" className="inline-flex min-h-14 items-center justify-center rounded-full border border-[#758171] bg-white/70 px-7 text-sm font-semibold text-[#40503d] transition-colors hover:bg-white" data-id="element-99" data-mp="2obdalqqi3xi8">
                Ver cómo funciona{' '}
                <ArrowDownIcon className="ml-2" size={16} data-id="element-100" data-mp="26xu6481o4mer" />
              </a>
            </div>
            <div className="mt-9 flex flex-wrap gap-x-6 gap-y-3 text-xs text-[#52604e]" data-id="element-101" data-mp="21yr3svd2ouah">
              <span className="flex items-center gap-1 text-[#9c7428]" data-id="element-102" data-mp="2gr2qxv8szgci">
                <StarIcon fill="currentColor" size={15} data-id="element-103" data-mp="2by02g1ivux36" />
                <StarIcon fill="currentColor" size={15} data-id="element-104" data-mp="2pqfzmlp3s0w6" />
                <StarIcon fill="currentColor" size={15} data-id="element-105" data-mp="2pov6n0ifsq0f" />
                <StarIcon fill="currentColor" size={15} data-id="element-106" data-mp="2krv1crtevrad" />
                <StarIcon fill="currentColor" size={15} data-id="element-107" data-mp="2ktfss8kfiu40" />
              </span>
              <span data-id="element-108" data-mp="2zo3wpia6lkhi">Pensado para días reales</span>
              <span data-id="element-109" data-mp="2upsnn9rpne0c">Empiezas hoy mismo</span>
              <span data-id="element-110" data-mp="2uq2eezkkxp73">Te acompaña donde estés</span>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.96
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.15
        }} className="relative order-1 mx-auto w-full max-w-xl lg:order-2" data-id="element-111" data-mp="15be18w460380">
            <div className="absolute -inset-5 bg-[#e4e4d5]/75" data-id="element-112" data-mp="1dsiexfspz1a" />
            <img src="https://images.unsplash.com/photo-1498837167922-ddd27525d352?auto=format&fit=crop&w=1100&q=85" alt="Ingredientes naturales sobre mesa de madera clara" className="relative h-[390px] w-full object-cover sm:h-[500px]" data-id="element-113" data-mp="5eccfs52omj7" />
            <div className="absolute inset-x-[10%] bottom-[-15px] flex items-end justify-center gap-2 sm:gap-4" data-id="element-114" data-mp="3du5voeqsgc3y">
              {[['HÁBITOS PARA UNA\nVIDA SALUDABLE', 'text-[#f8f5e9] bg-[#405a3b]'], ['DÉFICIT\nCALÓRICO', 'text-[#354a35] bg-[#d9ded0]'], ['COCINA\nANTIINFLAMATORIA', 'text-[#705f41] bg-[#eadfc8]'], ['PLANIFICADOR', 'text-[#fffdf6] bg-[#536a54]']].map(([title, colors], index) => <div key={title} className={`${colors} flex w-20 items-center justify-center px-1.5 py-3 text-center shadow-xl sm:w-28 sm:px-3 sm:py-7 ${index === 0 ? 'h-36 sm:h-48' : 'h-28 sm:h-40'}`} data-id="element-115" data-mp="2iiy89trg83y2" data-mpi={index}>
                  <span className="block w-full break-words text-[7px] font-bold leading-[1.35] tracking-[0.08em] sm:text-[10px] sm:leading-4 sm:tracking-[0.12em]" data-id="element-116" data-mp="24m2ob69nss38">
                    {title}
                    <span className="mt-2 block text-[6px] font-medium leading-[1.3] tracking-normal sm:text-[9px]" data-id="element-117" data-mp="1uv7wznhk32ax">
                      CÓDIGO FITNESS™
                    </span>
                  </span>
                </div>)}
            </div>
          </motion.div>
        </div>
      </section>

      <section id="sistema" className="relative overflow-hidden bg-[#fffefa] pb-10 pt-16 sm:pb-12 sm:pt-20" data-id="element-118" data-mp="1gunfqvrahejj">
        <LeafIcon aria-hidden="true" className="absolute -left-8 top-24 h-28 w-28 rotate-[22deg] text-[#dce7d4]/55" strokeWidth={1} data-id="element-119" data-mp="1byowtnoqcoqi" />
        <LeafIcon aria-hidden="true" className="absolute -right-5 bottom-28 h-32 w-32 -rotate-[35deg] text-[#e4eadc]/70" strokeWidth={1} data-id="element-120" data-mp="178ulbat4ktk5" />

        <div className="relative mx-auto max-w-7xl px-5 sm:px-8" data-id="element-121" data-mp="x93p94ox26hy">
          <div className="grid gap-16 lg:grid-cols-[.82fr_1.18fr] lg:items-center lg:gap-20" data-id="element-122" data-mp="1kzhj90r2aff6">
            <motion.figure initial={{
            opacity: 0,
            y: 18,
            rotate: -1
          }} whileInView={{
            opacity: 1,
            y: 0,
            rotate: -3
          }} viewport={{
            once: true,
            amount: 0.2
          }} transition={{
            duration: 0.65
          }} className="relative mx-auto w-full max-w-[430px] lg:max-w-none" data-id="element-123" data-mp="1l1u0tcswqnrp">
              <div aria-hidden="true" className="absolute inset-x-8 bottom-0 h-12 rounded-full bg-[#6d7c61]/20 blur-2xl" data-id="element-124" data-mp="3tepgusxkup7r" />
              <img src="https://cdn.magicpatterns.com/uploads/8qqeT9itbTEfWdJ6h8w9LR/ChatGPT_Image_17_jul_2026,_09_37_05.png" alt="Portada de la guía Hábitos para una Vida Saludable" className="relative w-full rounded-sm shadow-[18px_28px_42px_rgba(47,59,43,0.28)]" data-id="element-125" data-mp="6zwgrkulbp1e" />
            </motion.figure>

            <motion.div initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.15
          }} transition={{
            duration: 0.6,
            delay: 0.08
          }} data-id="element-126" data-mp="35j384ypkbnam">
              <p className="text-xs font-bold tracking-[0.2em] text-[#6d8063]" data-id="element-127" data-mp="2o87p3dkd9xkx">
                RESPIRA: NO ES FALTA DE VOLUNTAD
              </p>
              <h2 className="font-display mt-5 max-w-3xl text-4xl leading-[1.08] text-[#2d3b2c] sm:text-5xl" data-id="element-128" data-mp="2t82f7ewbij4x">
                Si abandonaste antes, el problema nunca fuiste tú.
              </h2>

              <div className="mt-7 max-w-3xl space-y-5 text-[15px] leading-7 text-[#63705f] sm:text-base" data-id="element-129" data-mp="32y5e1vq4erb6">
                <p data-id="element-130" data-mp="36xw6e3vapfht">
                  Fue seguir planes que nadie puede mantener cuando el día se
                  complica.
                </p>
                <p data-id="element-131" data-mp="3gwvdhi0ex32p">
                  Aquí es distinto: sabes qué comer, resuelves la semana con
                  calma y dejas de improvisar a última hora.
                </p>
                <p data-id="element-132" data-mp="3ltvjjsx9i5tt">
                  Sin perfección, sin castigos. Solo pequeñas decisiones que se
                  quedan contigo.
                </p>
              </div>

              <div className="mt-8" data-id="element-133" data-mp="1riqcsfqvpda9">
                <p className="mb-3 text-sm font-medium text-[#61725b]" data-id="element-134" data-mp="1rjruh32egy0y">
                  Acceso completo por{' '}
                  <span className="font-display text-2xl text-[#354a33]" data-id="element-135" data-mp="3wcdm8kq3ihk">
                    $29.99 USD
                  </span>
                </p>
                <a href={checkoutUrl} onClick={handleCheckoutClick} className="inline-flex min-h-14 items-center justify-center rounded-full bg-[#405a3b] px-7 text-sm font-bold tracking-[0.06em] text-white shadow-[0_10px_20px_rgba(48,69,46,0.14)] transition duration-300 hover:-translate-y-0.5 hover:bg-[#304a2d] hover:shadow-[0_14px_25px_rgba(48,69,46,0.2)]" data-id="element-136" data-mp="3w0eliv8rwvx2">
                  🍃 QUIERO EMPEZAR SIN COMPLICARME
                </a>
                <p className="mt-3 text-xs text-[#70806b]" data-id="element-137" data-mp="dlnljrvvih3v">
                  🔒 Pago seguro • Lo tienes en minutos • Descarga digital
                </p>
              </div>

              <div className="mt-10 border-t border-[#dbe0d4] pt-8" data-id="element-138" data-mp="2yb35c2wod5k0">
                <div className="flex items-start gap-4" data-id="element-139" data-mp="6j2lq3itgpij">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#e5eddf] text-[#4e6748]" data-id="element-140" data-mp="6jltirer5xiu">
                    <LeafIcon size={20} strokeWidth={1.5} data-id="element-141" data-mp="g95h2adeufk1" />
                  </span>
                  <div data-id="element-142" data-mp="gaynppo0wzs1">
                    <h3 className="font-display text-2xl text-[#354a33]" data-id="element-143" data-mp="bioxe8izxxp8">
                      Hábitos para una Vida Saludable
                    </h3>
                    <p className="mt-2 font-medium text-[#52634d]" data-id="element-144" data-mp="p7z7fj05e9p5">
                      Más de 55 páginas que te acompañan, paso a paso.
                    </p>
                    <p className="mt-3 max-w-2xl leading-7 text-[#657160]" data-id="element-145" data-mp="z89m781tzp6f">
                      Todo explicado con calma, para que sepas exactamente qué
                      hacer mañana.
                    </p>
                  </div>
                </div>

                <h4 className="mt-9 text-sm font-bold uppercase tracking-[0.14em] text-[#455b40]" data-id="element-146" data-mp="3117g777cgnsy">
                  Así se verá tu día a día
                </h4>
                <ul className="mt-5 grid gap-x-7 gap-y-3 sm:grid-cols-2" data-id="element-147" data-mp="1bir5dyfkxb96">
                  {learningPoints.map(point => <li key={point} className="flex items-start gap-2.5 text-sm leading-6 text-[#5b6858]" data-id="element-148" data-mp="1gj52ilfn70sf">
                      <CheckIcon className="mt-1 shrink-0 text-[#69845f]" size={15} strokeWidth={2} data-id="element-149" data-mp="16py11bo0w4xm" />
                      <span data-id="element-150" data-mp="wuwbwftqz2v1">{point}</span>
                    </li>)}
                </ul>
              </div>
            </motion.div>
          </div>

          <div className="mx-auto mt-14 max-w-5xl border-l-2 border-[#859c78] bg-[#eff3e9] px-7 py-8 sm:px-10 sm:py-9" data-id="element-151" data-mp="ns4zacp4y11t">
            <div className="flex items-start gap-4" data-id="element-152" data-mp="2d8w8bgtdwadj">
              <LeafIcon className="mt-0.5 shrink-0 text-[#627a58]" size={24} strokeWidth={1.5} aria-hidden="true" data-id="element-153" data-mp="2i6nx41yqfgdi" />
              <p className="font-display max-w-4xl text-2xl leading-8 text-[#3e5439] sm:text-[27px]" data-id="element-154" data-mp="2bqfez82k5npi">
                No necesitas más fuerza de voluntad. Necesitas una forma amable
                de volver a elegirte, incluso los días difíciles.
              </p>
            </div>
          </div>

          <div className="mt-16 grid border-y border-[#dfe4d8] sm:grid-cols-2 lg:grid-cols-4" data-id="element-155" data-mp="2zg0bktrmwjh9">
            {[['Sin dudas', 'sobre qué comer hoy', ListChecksIcon], ['55+', 'páginas que te acompañan', LeafIcon], ['30 días', 'para tomar impulso con calma', CalendarDaysIcon], ['4 semanas', 'de menús ya resueltos', CalendarDaysIcon], ['Paso a paso', 'sin complicarte en la cocina', CheckIcon], ['Listas', 'para comprar sin dudar', ListChecksIcon], ['Hoy mismo', 'lo tienes en tus manos', CheckIcon], ['En todos lados', 'celular, tablet y computadora', MonitorSmartphoneIcon]].map(([value, label, Icon], index) => {
            const StatIcon = Icon as typeof LeafIcon;
            return <div key={label as string} className={`min-h-36 p-6 sm:p-7 ${index < 4 ? 'border-b border-[#dfe4d8] lg:border-b-0' : ''} ${index % 2 === 0 ? 'sm:border-r sm:border-[#dfe4d8] lg:border-r' : 'lg:border-r'} ${index === 3 || index === 7 ? 'lg:border-r-0' : ''}`} data-id="element-156" data-mp="3ur6hl6v0r3mu" data-mpi={index}>
                  <StatIcon className="text-[#6d8662]" size={21} strokeWidth={1.4} data-id="element-157" data-mp="hagxkfk9080w" />
                  <p className="font-display mt-5 text-2xl text-[#3d5438]" data-id="element-158" data-mp="mbegiud3163g">
                    {value as string}
                  </p>
                  <p className="mt-1 text-sm leading-5 text-[#6a7567]" data-id="element-159" data-mp="w6ybnejto0r5">
                    {label as string}
                  </p>
                </div>;
          })}
          </div>

          <div className="mx-auto mt-16 max-w-4xl text-center" data-id="element-160" data-mp="1o01q4iik2ost">
            <p className="font-display text-2xl leading-9 text-[#40513e] sm:text-3xl" data-id="element-161" data-mp="1nxnsc1whqyhk">
              Algo a lo que volver cuando la semana se complique y no tengas
              ganas de pensar.
            </p>
            <p className="mt-6 text-base leading-7 text-[#667361]" data-id="element-162" data-mp="1xrxo7tkn6ex1">
              No es un archivo más para guardar. Es una mano cuando la
              necesitas, una comida a la vez.
            </p>
          </div>
        </div>
      </section>
    </>;
}